import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getDate } from "../../common/DisplayDate";

class SSNVerificationDetails extends Component {
  state = {
    ssnRows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadSsnVerification(nextProps);
    }
  }

  loadSsnVerification = (props) => {
    const ssnRows = [];
    if (props.reportData !== undefined) {
      const ssnInfo = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].AKAs[0].identity[0].SSNInfo[0]"
      );
      // _.forEach(ssnRecords, (record, index) => {
      if (ssnInfo !== undefined) {
        const issuedLocation = _.get(ssnInfo, "issuedLocation[0]._", "");
        const ssnIssued = _.get(ssnInfo, "SSNIssued[0]._", "");
        const ssnRisk = _.get(ssnInfo, "SSNRisk[0]._", "");
        const Valid = _.get(ssnInfo, "valid[0]._", "");

        const issuedStartDate = getDate(_.get(ssnInfo, "issuedStartDate[0]"));

        const issuedEndDate = getDate(_.get(ssnInfo, "issuedEndDate[0]"));

        ssnRows.push(
          <Table.Row key={`rep_liens_row_3`}>
            <Table.Cell className="text-bold">Issued:</Table.Cell>
            <Table.Cell>
              {issuedLocation}
              {ssnIssued}
              {ssnRisk}
            </Table.Cell>

            <Table.Cell className="text-bold">Verified:</Table.Cell>
            <Table.Cell> {Valid} </Table.Cell>

            <Table.Cell className="text-bold">Years Issued:</Table.Cell>
            <Table.Cell>
              {issuedStartDate} - {issuedEndDate}
            </Table.Cell>
          </Table.Row>
        );
      }
      // });

      this.setState({ ssnRows });
    }
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"SSN Verification"}
        rows={this.state.ssnRows}
      />
    );
  }
}

export default SSNVerificationDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/SSNVerificationDetails.js